module.exports = __webpack_public_path__ + "img/3.7e25a517.png";